import { Theme, useMediaQuery } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { ApiActions } from '@orientaction/api-actions';
import { ProfileMenu } from '@orientaction/commons';
import { useAlert, useProfileMenu } from '@orientaction/hooks';
import { appLanguage } from '@orientaction/reducers';
import { userService } from '@orientaction/services';
import { getFromLS, isAdmin } from '@orientaction/utils';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useEbookReaderHeaderStyles } from './EbookReaderHeader.styles';

type EbookReaderHeaderProps = {
  index?: number;
  toBack: string;
};

const EbookReaderHeader = ({ index, toBack }: EbookReaderHeaderProps) => {
  const classes = useEbookReaderHeaderStyles();
  const history = useHistory();
  const alert = useAlert();
  const dispatch = useDispatch();
  const lang: string = useSelector(appLanguage);
  const xsDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));
  const user = getFromLS('userInfos') ? JSON.parse(getFromLS('userInfos') || '') : undefined;
  const { open, anchorRef, handleToggle, handleClose, goToProfileEdit, logout } = useProfileMenu({
    user,
  });

  const goBack = () => {
    if (!toBack) {
      history.goBack();
      return;
    }

    if (xsDown && toBack === '/mes-ressources') {
      sessionStorage.setItem('redirect', JSON.stringify(['ebooks', index]));
    }

    history.push(toBack === '/mes-ressources' && lang !== 'FR' ? '/en/my-resources' : toBack);
  };

  const switchRole = async () => {
    try {
      const isSecondRoleActivated = user?.company_user_role?.id === 4;
      const token = getFromLS('userToken') || '';
      const { data } = await userService.switchRole(token, !isSecondRoleActivated);
      localStorage.setItem('userInfos', JSON.stringify(data));
      history.push('/');
    } catch (error) {
      alert.openSimpleAlert();
    }
  };

  const goHome = () => {
    dispatch(ApiActions.setTabLayout(0 as any));
    history.push(user ? (isAdmin(user) ? '/admin/users-resultats' : '/main') : '/');
  };

  return (
    <header id="ebook-top" className={classes.header}>
      <button type="button" className={classes.headerBackButton} onClick={goBack}>
        <ArrowBackIcon className={classes.headerBackIcon} />
        <span>Retour</span>
      </button>

      {user && (
        <div className={classes.profileWrapper}>
          <button
            type="button"
            ref={anchorRef as any}
            className={classes.profileButton}
            onClick={handleToggle}
            aria-label="Ouvrir le menu utilisateur"
            aria-expanded={open}>
            <span className={classes.profileInitials}>
              {`${user?.firstname?.charAt(0).toUpperCase() || ''}${
                user?.lastname?.charAt(0).toUpperCase() || ''
              }`}
            </span>
            <span className={classes.profileName}>{`${user.firstname} ${user.lastname}`}</span>
            {open ? (
              <KeyboardArrowUpIcon className={classes.profileIcon} />
            ) : (
              <KeyboardArrowDownIcon className={classes.profileIcon} />
            )}
          </button>

          <ProfileMenu
            open={open}
            anchorRef={anchorRef}
            handleToggle={handleToggle}
            handleClose={handleClose}
            goToProfileEdit={goToProfileEdit}
            logout={logout}
            user={user}
            switchRole={switchRole}
          />
        </div>
      )}
    </header>
  );
};

export default EbookReaderHeader;
